import { z } from '../zod.js';
/** ISO 8601 timestamp in UTC (`Z` suffix), with optional fractional seconds. */
export const IsoTimestamp = z.iso.datetime();
/** A UUID of any version (documents use v7; seeded reference rows use v5). */
export const Uuid = z.uuid();
/** Immutable 16-character base62 document handle. */
export const Fid = z.string().regex(/^[A-Za-z0-9]{16}$/);
/** Release identifier: a commit, a tag or `dev`. */
export const ReleaseId = z.string().min(1).max(200);
/** A row version (`rv`, `version`) or a body or metadata version: a counter from 1. */
export const RowVersion = z.number().int().min(1);
/** Any JSON value, as a `jsonb` column stores it. */
export const JsonValue = z.json();
/** The `:id` of a row that is not a document (a type, a field, a template, a sidebar item). */
export const IdParams = z.strictObject({ id: Uuid });
//# sourceMappingURL=common.js.map